import types from '../mutation-types';
import BotifyToolsAPI from 'dashboard/api/botifyTools';

const state = {
  records: [],
  uiFlags: {
    isInitialized: false,
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getTools($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

const withBotUuid = (data, rootGetters) => {
  const botUuid = rootGetters['newBotify/getBotifyId'];
  if (!botUuid) {
    throw new Error('botUuid not found. Make sure newBotify/get has been called.');
  }
  return { ...(data || {}), bot_uuid: botUuid };
};

export const actions = {
  fetch: async ({ commit }) => {
    commit(types.SET_BOTIFY_TOOLS_UI_FLAG, { isFetching: true });
    try {
      const response = await BotifyToolsAPI.getTools();
      commit(types.SET_BOTIFY_TOOLS, response.data);
      commit(types.SET_BOTIFY_TOOLS_UI_FLAG, {
        isFetching: false,
        isInitialized: true,
      });
      return response.data;
    } catch (error) {
      commit(types.SET_BOTIFY_TOOLS_UI_FLAG, {
        isFetching: false,
        isInitialized: true,
      });
      throw error;
    }
  },

  create: async ({ commit, dispatch, rootGetters }, data) => {
    commit(types.SET_BOTIFY_TOOLS_UI_FLAG, { isCreating: true });
    try {
      const response = await BotifyToolsAPI.createTool(
        withBotUuid(data, rootGetters)
      );
      commit(types.SET_BOTIFY_TOOLS_UI_FLAG, { isCreating: false });
      await dispatch('fetch');
      return response.data;
    } catch (error) {
      commit(types.SET_BOTIFY_TOOLS_UI_FLAG, { isCreating: false });
      throw error;
    }
  },

  update: async ({ commit, dispatch, rootGetters }, data) => {
    commit(types.SET_BOTIFY_TOOLS_UI_FLAG, { isUpdating: true });
    try {
      const response = await BotifyToolsAPI.updateTool(
        withBotUuid(data, rootGetters)
      );
      commit(types.SET_BOTIFY_TOOLS_UI_FLAG, { isUpdating: false });
      await dispatch('fetch');
      return response.data;
    } catch (error) {
      commit(types.SET_BOTIFY_TOOLS_UI_FLAG, { isUpdating: false });
      throw error;
    }
  },

  delete: async ({ commit, dispatch, rootGetters }, data) => {
    commit(types.SET_BOTIFY_TOOLS_UI_FLAG, { isDeleting: true });
    try {
      await BotifyToolsAPI.deleteTool(withBotUuid(data, rootGetters));
      commit(types.SET_BOTIFY_TOOLS_UI_FLAG, { isDeleting: false });
      await dispatch('fetch');
    } catch (error) {
      commit(types.SET_BOTIFY_TOOLS_UI_FLAG, { isDeleting: false });
      throw error;
    }
  },

  deleteByName: async (
    { state: moduleState, commit, dispatch, rootGetters },
    { name }
  ) => {
    const tool = moduleState.records.find(t => t.name === name);
    if (!tool) throw new Error(`Tool '${name}' not found in store`);

    commit(types.SET_BOTIFY_TOOLS_UI_FLAG, { isDeleting: true });
    try {
      await BotifyToolsAPI.deleteTool(withBotUuid(tool, rootGetters));
      commit(types.SET_BOTIFY_TOOLS_UI_FLAG, { isDeleting: false });
      await dispatch('fetch');
    } catch (e) {
      commit(types.SET_BOTIFY_TOOLS_UI_FLAG, { isDeleting: false });
      throw e;
    }
  },
};

export const mutations = {
  [types.SET_BOTIFY_TOOLS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_BOTIFY_TOOLS]($state, data) {
    $state.records = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
